/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_3Inputs */

const en_mk_proof_3 = /** @type {(inputs: Mk_Proof_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The server refuses task complete without passing evidence; every --override is recorded with a reason. The verifier can be Local, the Bystep Reviewer, or GitHub CI.`)
};

const id_mk_proof_3 = /** @type {(inputs: Mk_Proof_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Server menolak task complete tanpa bukti lulus; setiap --override tercatat dengan alasan. Verifikator bisa Lokal, Penilai Bystep, atau CI GitHub.`)
};

/**
* | output |
* | --- |
* | "The server refuses task complete without passing evidence; every --override is recorded with a reason. The verifier can be Local, the Bystep Reviewer, or Git..." |
*
* @param {Mk_Proof_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_3 = /** @type {((inputs?: Mk_Proof_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_3(inputs)
	return en_mk_proof_3(inputs)
});